import styles from './code-block.module.css';

type P = { value: unknown };

const formatValue = (value: unknown) => {
  if (typeof value === 'string') {
    return value;
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

const CodeBlock = ({ value }: P) => <pre className={styles['code-block']}>{formatValue(value)}</pre>;

export default CodeBlock;
